/**
 * Door Reveal
 * Trick or Treat (halloween) reveal for the random game picker: shut double doors that knock
 * while closed, then swing open (and fade) to reveal the content behind them. Purely visual.
 */

import React from 'react';

import type { CardRevealProps } from '../types';
import styles from './halloween.module.css';

export const DoorReveal: React.FC<CardRevealProps> = ({ open, children }) => (
  <div className={styles.frame} data-state={open ? 'open' : 'closed'}>
    {children}
    <div className={styles.doors} aria-hidden="true">
      <div className={`${styles.door} ${styles.doorLeft}`} />
      <div className={`${styles.door} ${styles.doorRight}`} />
    </div>
  </div>
);
